import { track } from "@amplitude/unified"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  event({ params }) {
    const { eventName, eventProperties } = params

    track(eventName, eventProperties)
  }
}
